import React from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const MetricTrendChart = ({ data, labels, color }) => {
  const chartData = {
    labels,
    datasets: [
      {
        label: 'Trend',
        data,
        borderColor: color,
        backgroundColor: `${color}20`,
        tension: 0.3,
        fill: true,
        pointRadius: 4,
        pointBackgroundColor: color,
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false
      }
    },
    scales: {
      y: {
        beginAtZero: true
      }
    }
  };

  return <Line data={chartData} options={options} />;
};

export default MetricTrendChart;